<template>
  <ion-content class="ficha-scroll">
    <div class="ficha">

      <div class="ficha-cabecera">
        <div>
          <h2 class="ficha-titulo">Editar siniestro</h2>
          <p class="ficha-sub">{{ expediente ? ('Expediente ' + expediente) : 'Sin nº de expediente' }}</p>
        </div>
        <button type="button" class="ficha-cerrar" @click="closeModal()">
          <ion-icon :icon="close"></ion-icon>
        </button>
      </div>

      <!-- Informe de error concreto -->
      <div v-if="reporteError" class="aviso aviso-error">
        <div class="aviso-error-titulo">No se pudo guardar el siniestro ({{ reporteError.hora }})</div>
        <ul class="aviso-error-lista">
          <li v-for="(m, i) in reporteError.mensajes" :key="i">{{ m }}</li>
        </ul>
        <div class="aviso-acciones">
          <button type="button" class="btn-mini" @click="copiarReporte">
            {{ reporteCopiado ? 'Copiado ✓' : 'Copiar informe' }}
          </button>
          <button type="button" class="btn-mini btn-mini-gris" @click="reporteError = null">Cerrar</button>
        </div>
      </div>

      <!-- Afectados -->
      <div class="ficha-seccion-titulo">Afectados</div>
      <div v-for="(cliente, idx) in clientes" :key="idx" class="tarjeta-afectado">
        <div class="tarjeta-cabecera">
          <span class="tarjeta-titulo">Afectado {{ idx + 1 }}</span>
          <button type="button" class="btn-mini btn-mini-rojo" @click="eliminarImplicado(cliente, idx)">
            Eliminar implicado
          </button>
        </div>
        <div class="grid-campos">
          <div class="campo">
            <label>DNI / NIE</label>
            <input type="text" v-model="cliente.dni" placeholder="12345678Z" @input="cliente.dni = (cliente.dni || '').toUpperCase()" />
          </div>
          <div class="campo">
            <label>Nombre y apellidos</label>
            <input type="text" v-model="cliente.name" placeholder="Nombre completo" />
          </div>
          <div class="campo">
            <label>Móvil</label>
            <input type="tel" v-model="cliente.movil" placeholder="600000000" />
          </div>
          <div class="campo">
            <label>Teléfono</label>
            <input type="tel" v-model="cliente.telefono" placeholder="956000000" />
          </div>
          <div class="campo">
            <label>Nº de póliza</label>
            <input type="text" v-model="cliente.num_poliza" placeholder="Número de póliza" />
          </div>
          <div class="campo">
            <label>Compañía</label>
            <select v-model="cliente.compania_id">
              <option :value="null" disabled>Selecciona compañía</option>
              <option v-for="compania in companias" :value="compania.id" :key="compania.id">{{ compania.nombre }}</option>
            </select>
          </div>
          <div class="campo">
            <label>Población</label>
            <input type="text" v-model="cliente.poblacion" placeholder="Población" />
          </div>
          <div class="campo">
            <label>Dirección</label>
            <input type="text" v-model="cliente.direccion" placeholder="Calle, número…" />
          </div>
        </div>
      </div>

      <button type="button" class="btn-anadir" @click="anadirAfectado">+ Añadir otro afectado</button>

      <!-- Datos del siniestro -->
      <div class="ficha-seccion-titulo">Datos del siniestro</div>
      <div class="grid-campos">
        <div class="campo">
          <label>Fecha del siniestro</label>
          <input type="date" v-model="fecha_siniestro" />
        </div>
        <div class="campo">
          <label>Matrícula</label>
          <input type="text" v-model="matricula" placeholder="0000XXX" @input="matricula = (matricula || '').toUpperCase()" />
        </div>
        <div class="campo">
          <label>Número de expediente <small>(opcional)</small></label>
          <input type="text" v-model="expediente" placeholder="Ej. SD 14106" />
        </div>
        <div class="campo">
          <label>ID expediente EPLAN <small>(opcional)</small></label>
          <input type="text" v-model="expediente_id" placeholder="Ej. 16917" />
        </div>
        <div class="campo campo-ancho">
          <label>Descripción del siniestro (designa)</label>
          <textarea v-model="descripcion" rows="2" placeholder="Descripción para la designa"></textarea>
        </div>
        <div class="campo campo-ancho">
          <label>Versión del sucedido</label>
          <textarea v-model="version_suceso" rows="3" placeholder="Relato de lo ocurrido"></textarea>
        </div>
        <div class="campo campo-ancho">
          <label>Observaciones</label>
          <textarea v-model="observacion" rows="2" placeholder="Observaciones internas"></textarea>
        </div>
      </div>

      <div class="ficha-botonera">
        <ion-button color="medium" fill="outline" @click="closeModal()">Cancelar</ion-button>
        <ion-button color="dark" :disabled="enviando" @click="editSiniesto">
          {{ enviando ? 'Guardando…' : 'Guardar cambios' }}
        </ion-button>
      </div>

    </div>
  </ion-content>
</template>

<script>

import { defineComponent } from 'vue';
import { close } from 'ionicons/icons';
import { modalController } from '@ionic/vue';
import axios from 'axios'
import toast from '@/plugins/toast'

export default defineComponent({
  name: 'EditarSiniestro',
  props: ['data_siniestro'],
  setup() {
    return { close }
  },
  data(){
    return{
        num_clientes : 1,
        clientes: [],
        companias: [],
        version_suceso: null,
        observacion: null,
        expediente: null,
        expediente_id: null,
        descripcion: null,
        fecha_siniestro: null,
        matricula: null,
        enviando: false,
        reporteError: null,
        reporteCopiado: false,
    }
  },
  created(){
    this.matricula = this.data_siniestro.matricula
    this.fecha_siniestro = this.data_siniestro.fecha_siniestro
    this.descripcion = this.data_siniestro.descripcion
    this.version_suceso = this.data_siniestro.version_suceso
    this.expediente = this.data_siniestro.expediente
    this.expediente_id = this.data_siniestro.expediente_id
    this.observacion = this.data_siniestro.observacion
    this.num_clientes = this.data_siniestro.clientes.length
  },
  mounted(){
    this.getCompanias()
  },
  methods:{
    async closeModal(data = null) {
      const modal = await modalController
      return modal.dismiss(data == null ? 'close-button' : data);
    },
    getCompanias(){
      axios.get('/api/companias?all=true')
      .then(res => {
        this.companias = res.data.data
        this.clientes = this.data_siniestro.clientes
      })
      .catch(error => {
        console.log(error)
      })
    },
    anadirAfectado(){
      this.clientes.push({
        id: null, name: '', telefono: '', movil: '', dni: '',
        num_poliza: '', compania_id: null, poblacion: '', direccion: '',
      });
      this.num_clientes = this.clientes.length;
    },
    eliminarImplicado(cliente, index){
      if (cliente.id) {
        // Cliente ya existente: se elimina en el servidor (misma lógica que antes)
        this.deleteClient(cliente.id);
      }
      this.clientes.splice(index, 1);
      this.num_clientes = this.clientes.length;
    },
    async editSiniesto(){

      if (this.data_siniestro.clientes.length > this.clientes.length) {
        toast.openToast("No puedes disminuir el número de afectados","error",2500)
        return
      }

      this.reporteError = null;
      this.enviando = true;
      var loading = await toast.showLoading()

      await loading.present();
      axios.post('/api/siniestros/'+this.data_siniestro.id,{
        clientes : this.clientes,
        fecha_siniestro: this.fecha_siniestro,
        descripcion: this.descripcion,
        matricula: this.matricula,
        version_suceso: this.version_suceso,
        expediente: this.expediente,
        expediente_id: this.expediente_id,
        observacion: this.observacion,
      })
      .then(data => {
        loading.dismiss()
        this.enviando = false
        this.closeModal('reload')
        toast.openToast("Siniestro actualizado correctamente","success",2000)
        console.log(data)
      }).catch(err => {
        loading.dismiss()
        this.enviando = false
        this.reporteError = this.construirReporte(err)
        console.log(err)
      })
    },
    deleteClient(id){
      axios.post('/api/siniestros/remove/user', { 'user_id': id, 'siniestro_id': this.data_siniestro.id })
        .then(response => {
          console.log(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    },
    construirReporte(err){
      const ahora = new Date();
      const mensajes = [];
      const resp = err?.response;

      if (!resp) {
        mensajes.push('No hubo respuesta del servidor (fallo de conexión). Comprueba tu conexión e inténtalo de nuevo.');
      } else {
        const msg = resp.data?.error?.message;
        if (Array.isArray(msg)) {
          mensajes.push(...msg);
        } else if (msg && typeof msg === 'object') {
          Object.values(msg).forEach((lista) => mensajes.push(...[].concat(lista)));
        } else if (typeof msg === 'string') {
          mensajes.push(msg);
        } else {
          mensajes.push(`Error ${resp.status} del servidor sin detalle.`);
        }
      }

      return {
        hora: ahora.toLocaleTimeString(),
        mensajes,
        texto: [
          `[Reclasin] Error al editar un siniestro`,
          `Fecha: ${ahora.toLocaleString()}`,
          `Siniestro: #${this.data_siniestro.id}${this.expediente ? ' (' + this.expediente + ')' : ''}`,
          `Petición: POST /api/siniestros/${this.data_siniestro.id} → ${resp ? 'HTTP ' + resp.status : 'sin respuesta'}`,
          `Detalle:`,
          ...mensajes.map((m) => `  - ${m}`),
        ].join('\n'),
      };
    },
    async copiarReporte(){
      try {
        await navigator.clipboard.writeText(this.reporteError.texto);
        this.reporteCopiado = true;
        setTimeout(() => { this.reporteCopiado = false; }, 2000);
      } catch (e) {
        toast.openToast('No se pudo copiar al portapapeles', 'error', 2000);
      }
    },
  }
});
</script>

<style scoped>
.ficha-scroll {
  --background: #ffffff;
}

.ficha {
  padding: 20px 24px 24px;
}

.ficha-cabecera {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 14px;
}

.ficha-titulo {
  margin: 0 0 2px;
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.ficha-sub {
  margin: 0;
  font-size: 13px;
  color: #94a3b8 !important;
}

.ficha-cerrar {
  border: none;
  background: #111827;
  color: #fff;
  border-radius: 8px;
  width: 30px;
  height: 30px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ficha-seccion-titulo {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
  margin: 18px 0 8px;
}

.aviso {
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 12px;
}

.aviso-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
}

.aviso-error-titulo {
  font-weight: 700;
  margin-bottom: 4px;
}

.aviso-error-lista {
  margin: 0 0 6px;
  padding-left: 18px;
}

.aviso-acciones {
  display: flex;
  gap: 8px;
}

.btn-mini {
  border: none;
  background: #111827;
  color: #fff;
  border-radius: 7px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

.btn-mini-gris { background: #e5e7eb; color: #374151; }
.btn-mini-rojo { background: #fee2e2; color: #b91c1c; }

.tarjeta-afectado {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #fafafa;
}

.tarjeta-cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.tarjeta-titulo {
  font-weight: 700;
  font-size: 14px;
  color: #111827;
}

.grid-campos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 14px;
}

.campo-ancho { grid-column: 1 / -1; }

.campo label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 3px;
  text-align: left;
}

.campo input,
.campo select,
.campo textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 14px;
  background: #fff;
  box-sizing: border-box;
  color: #111827;
}

.campo input:focus,
.campo select:focus,
.campo textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.btn-anadir {
  border: 1px dashed #9ca3af;
  background: transparent;
  color: #374151;
  border-radius: 10px;
  width: 100%;
  padding: 9px;
  font-size: 13px;
  cursor: pointer;
  margin-bottom: 6px;
}

.btn-anadir:hover { background: #f3f4f6; }

.ficha-botonera {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

ion-button {
  --border-radius: 10px;
  text-transform: none;
}

@media (max-width: 640px) {
  .grid-campos { grid-template-columns: 1fr; }
}
</style>
